/**
 * 提现
 */
export default [
  {
    path: '/about',
    meta: {
      title: '公司简介'
    },
    // children: [
    //   {
    //     path: 'intro',
    //     name: 'intro',
    //     component: (resolve) => {
    //       require(['$views/about/intro.vue'], resolve)
    //     }
    //   }
    // ],
    component: (resolve) => {
      require(['$views/about/index.vue'], resolve)
    }
  },
  {
    path: '/about/manager',
    meta: {
      title: '管理团队',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/manager.vue'], resolve)
    }
  },
  {
    path: '/about/data',
    meta: {
      title: '数据披露',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/data.vue'], resolve)
    }
  },
  {
    path: '/about/risk',
    meta: {
      title: '风险管理',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/risk.vue'], resolve)
    }
  },
  {
    path: '/about/custody',
    meta: {
      title: '银行存管',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/custody.vue'], resolve)
    }
  },
  {
    path: '/about/audit',
    meta: {
      title: '审计信息',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/audit.vue'], resolve)
    }
  },
  {
    path: '/about/contact',
    meta: {
      title: '联系我们',
      containerClass: 'ssui-bg-cb1'
    },
    component: (resolve) => {
      require(['$views/about/contact.vue'], resolve)
    }
  },
  // {
  //   path: '/about/fail',
  //   meta: {
  //     title: '提现结果',
  //     containerClass: 'ssui-bg-cb1'
  //   },
  //   component: (resolve) => {
  //     require(['$views/about/resultFail.vue'], resolve)
  //   }
  // },
  // {
  //   path: '/about/rules',
  //   meta: {
  //     title: '提现规则',
  //     containerClass: 'ssui-bg-cb1'
  //   },
  //   component: (resolve) => {
  //     require(['$views/about/rules.vue'], resolve)
  //   }
  // }
]



// WEBPACK FOOTER //
// ./src/routes/modules/about.js